import { useState } from "react";
import "./login.css";
import { CloseSquareFilled } from '@ant-design/icons';
import { Alert } from 'antd';
import {
  StyledInput,
  StyledPasswordInput,
} from "../login-module/customComponents/styled_input";
import { Button } from "antd";
import { useNavigate, Link, Navigate } from "react-router-dom";
function InputLink() {
	const [link, setLink] = useState("");
	const [validLink,setValidLink] = useState(true);
	const navigate = useNavigate();

  const onChangeHandler = (e) => {
    const newValue = e.target.value;
    setLink(newValue);
    console.log("Input value:", newValue);
  };
  const onClose = (e) => {
	console.log(e, 'I was closed.');
  };

  const onClickHandler = () => {
	const urlPattern = /https?:\/\/[^\/]+(\/.*)$/;
	const match = link.match(urlPattern);
	if(match){
		setValidLink(true)
		const path = match ? match[1] : '';
		navigate(path)
		console.log(path,"path");
	}
	else{
		alert("Enter a valid URL");
		setValidLink(false)
	}
    console.log("Proceed with link:", link);
  };

  return (
    <div
      className="email-container"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", 
      }}
    >
      <StyledInput
        className="login-email"
        value={link}
        onChange={onChangeHandler} 
        placeholder="Enter the copied link"
        style={{ width: "100%", maxWidth: "400px" }}
      />
      <Button
        onClick={onClickHandler}
        style={{
          backgroundColor: "#FF0083",
          color: "#FFFFFF",
          minHeight: "40px",
          width: "130px",
          marginTop: "10px",
        }}
      >
        Proceed
      </Button>
    </div>
  );
}

export default InputLink;
